import { Controller } from "@hotwired/stimulus"

// Native <dialog> for site contact / game-page update suggestions.
export default class extends Controller {
  static targets = ["dialog", "formTemplate", "title", "lede", "regarding"]

  // External tools (e.g. the GitHub-hosted save analyzers) link to #contact.
  connect() {
    if (window.location.hash !== "#contact") return

    history.replaceState(history.state, "", window.location.pathname + window.location.search)
    this.open()
  }

  open(event) {
    event?.preventDefault()
    if (!this.hasDialogTarget) return

    const button = event?.currentTarget
    const gameTitle = button?.dataset?.gameTitle?.trim() || ""
    const gameUrl = button?.dataset?.gameUrl?.trim() || ""

    this.#ensureForm()
    this.#applyContext({ gameTitle, gameUrl })
    this.#clearMessage()
    this.dialogTarget.showModal()
  }

  close(event) {
    event?.preventDefault()
    if (!this.hasDialogTarget) return
    this.dialogTarget.close()
  }

  // Click on the backdrop (the dialog element itself) closes; clicks inside the panel do not.
  backdropClose(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  #ensureForm() {
    if (!this.hasFormTemplateTarget) return
    const current = this.dialogTarget.querySelector("#contact-form")
    if (!current || current.classList.contains("contact-modal__success")) {
      const panel = this.dialogTarget.querySelector(".contact-modal__panel")
      if (!panel) return
      current?.remove()
      panel.appendChild(this.formTemplateTarget.content.cloneNode(true))
    }
  }

  #applyContext({ gameTitle, gameUrl }) {
    const form = this.dialogTarget.querySelector("#contact-form")
    if (!form) return

    const titleInput = form.querySelector("[name='contact[game_title]']")
    const urlInput = form.querySelector("[name='contact[game_url]']")
    if (titleInput) titleInput.value = gameTitle
    if (urlInput) urlInput.value = gameUrl

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = gameTitle ? "Suggest an update" : "Contact"
    }
    if (this.hasLedeTarget) {
      this.ledeTarget.textContent = gameTitle
        ? "Share a correction, a link, or anything else about this page."
        : "Send a note about the catalog, a tool, or anything else."
    }
    if (this.hasRegardingTarget) {
      if (gameTitle) {
        this.regardingTarget.hidden = false
        this.regardingTarget.textContent = `Regarding: ${gameTitle}`
      } else {
        this.regardingTarget.hidden = true
        this.regardingTarget.textContent = ""
      }
    }
  }

  // Keep name/email across opens; always start with a blank message.
  #clearMessage() {
    const form = this.dialogTarget.querySelector("#contact-form")
    const message = form?.querySelector("[name='contact[message]']")
    if (message) message.value = ""
  }
}
